import React, { Component } from 'react';
import { Button } from 'antd';
import { Plus, ReceiptText } from 'lucide-react';
import { PriceTable, PriceAnalytics } from './elements';
import Inherit from '../../core/inherit';
import { Layout, TableSkeleton, AnalyticsSkeleton, PageHeader } from '../common';
import PriceController from './price.controller';
import withNavigate from '../../core/withNavigate';

class ShelfPrices extends Inherit(PriceController, Component) {
    state = {
        loading: true,
        prices: [],
        rows: []
    };

    render() {
        const { rows, loading, prices } = this.state;

        return (
            <Layout current="price">
                <PageHeader
                    icon={<ReceiptText />}
                    title="Listas de Precio"
                    description="Gestiona las listas de precios para clientes modernos y tradicionales"
                    actions={
                        !loading && (
                            <Button type="primary" icon={<Plus />} onClick={() => this.navigatePriceList('')}>
                                Crear Nueva Lista
                            </Button>
                        )
                    }
                />

                {loading ? (
                    <div className="space-y-4">
                        <AnalyticsSkeleton count={3} />
                        <TableSkeleton rows={10} columns={5} />
                    </div>
                ) : (
                    <div className="space-y-4 animate-in">
                        <PriceAnalytics prices={prices} />
                        <PriceTable
                            rows={rows}
                            prices={prices}
                            loading={loading}
                            setRows={this.setRows.bind(this)}
                            navigatePriceList={this.navigatePriceList.bind(this)}
                        />
                    </div>
                )}
            </Layout>
        );
    }
}

export default withNavigate(ShelfPrices);
